<template lang="pug">
v-dialog(
    v-model="isModalActive"
    :width="dialogWidth"
    persistent
    content-class="elevation-0"
)
    v-card(class="elevation-4 modal-list-wrapper")
        .text-xs-right
            v-btn(
                icon
                @click="closeDialog"
            )
                v-icon mdi-close
        .text-xs-center 
            h2 {{ lenderName }} Plans Selection
        template(v-if="plans.length === 0")
            p(style="width: 55%; margin: 0 auto;") Currently, there are no plans available at this time. If the problem persists, contact OnCallAir Finance+ Customer Service at <a href="tel:1-786-375-9482">786-375-9482</a>.
            br
            br
        template(v-else)
            div
                v-list(two-line style="z-index: 0" :class="[$vuetify.breakpoint.smAndDown ? 'pl-0' : 'pl-4', 'max-height']" wrap)
                    v-list-tile(
                        v-for="plan in plans"
                        :key="plan.planNumber"
                        :avatar='true'
                    )
                        v-list-tile-avatar
                            v-checkbox(
                                v-model="selectedPlansMap[plan.planNumber]"
                            )
                        v-list-tile-content
                            v-list-tile-title Plan {{ plan.planNumber }}: {{ plan.planLength }} Months
                            v-list-tile-sub-title(:title="plan.planDescription") {{ plan.planDescription }}
                            v-list-tile-sub-title Merchant Fee*: {{ plan.merchantFee }}%
    template(v-if="plans.length > 0")
        v-card(class="elevation-8 modal-controls")
            p(v-if="additionalInfo" style="width: 55%; font-size: 10px; margin: 0 auto") {{ additionalInfo }}
            v-btn(@click="selectAll()" :disabled="allSelected") Select All
            v-btn(@click="deselectAll()" :disabled="noneSelected") Deselect All
            SaveButton(
                :isEnabled="saveable"
                :onSave="save"
            )

</template>

<script>
import SaveButton from '@/components/SaveButton.vue'
export default {
    name: 'plans-selection-modal',
    components: {
        SaveButton
    },
    async mounted() {
        // Adding listener to resize window dynamically
        window.addEventListener('resize', this.onWindowResize)

        // Transforming plans to a map with planNumber as the key
        this.savedPlansMap = await this.plans
        .reduce((acc, plan) => {
            { acc[plan.planNumber] = plan.isActive }
            return acc
        }, {})

        // Mirroring the currently selected plans to the plans saved on the DB
        this.selectedPlansMap = {...this.savedPlansMap}
    },
    beforeDestroy() {
        // Cleaning up listener
        window.removeEventListener('resize', this.onWindowResize)
    },
    data() {
        return {
            selectedPlansMap: {},
            savedPlansMap: {},
            windowWidth: window.innerWidth,
            modalActive: this.isModalActive,
        }
    },
    props: {
        isModalActive: {
            type: Boolean,
            default: false
        },
        lenderName: {
            type: String,
            default: ''
        },
        plans: {
            type: Array,
            default: () => []
        },
        additionalInfo: {
            type: String,
            default: ''
        }
    },
    methods: {
        save() {
            // Parent components implement save functionality
            this.$emit('save', this.selectedPlansMap, this.savedPlansMap)

            // Similar to what happens during mounting but flipped. We are now saying that the saved plans
            // ARE the slected plans
            this.savedPlansMap = {...this.selectedPlansMap}
        },
        closeDialog() {
            // Parent components implement close functionality
            this.$emit('close')
        },
        selectAll() {
            Object.keys(this.selectedPlansMap).forEach(key => this.selectedPlansMap[key] = true)
        },
        deselectAll() {
            Object.keys(this.selectedPlansMap).forEach(key => this.selectedPlansMap[key] = false)
        },
        onWindowResize() {
            this.windowWidth = window.innerWidth
        }
    },
    computed: {
        saveable() {
            return !this.isSaving && (JSON.stringify(this.selectedPlansMap) != JSON.stringify(this.savedPlansMap))
        },
        allSelected() {
            return !Object.keys(this.selectedPlansMap).some((plan) => this.selectedPlansMap[plan] == false)
        },
        noneSelected() {
            return !Object.keys(this.selectedPlansMap).some((plan) => this.selectedPlansMap[plan] == true)
        },
        dialogWidth() {
            if (this.windowWidth > 820) {
                return '50%'
            }
            else {
                return 'auto'
            }
        }
    },
}
</script>

<style lang="scss">
@import '../style_partials/global_vars';
.max-height {
  max-height: 300px;
  overflow-y: scroll;
}

.modal-controls {
    margin: 0 auto;
    background-color: white;
    padding: 10px;
    width: 100%;
    border-radius: 0px 0px 10px 10px;
}

.modal-list-wrapper {
    border-radius: 10px 10px 10px 10px;
    margin: 0 auto;
    width: 100%;
}

.wrap-text {
  -webkit-line-clamp: unset !important;
}

</style>